<script>
    import { getContext } from "svelte";
    import {
        Alert,
        Col,
        Container,
        FormGroup,
        Input,
        Row,
        Spinner
    } from 'sveltestrap';

    import { createForm } from "svelte-forms-lib";
    import * as yup from "yup";
    import Email from "./Fields/Email.svelte";
	import Password from "./Fields/Password.svelte";
    import Recaptcha from "./Fields/Recaptcha.svelte";

    import { _ } from "svelte-i18n";

    let result = null;

    let apiUrl = getContext("apiUrl");

    const { form, errors, handleChange, isSubmitting, handleSubmit, isValid } = createForm({
        initialValues: {
            email: "",
            password: "",
            keepLogged: true,
        },
        validationSchema: yup.object().shape({
            email: yup
                .string($_("components.Forms.errorMessage.string"))
                .email($_("components.Forms.errorMessage.email"))
                .required($_("components.Forms.errorMessage.required")),
            password: yup
                .string($_("components.Forms.errorMessage.string"))
                .required($_("components.Forms.errorMessage.required")),
            keepLogged: yup.boolean(),
        }),
        onSubmit: async () => {
            var Form = new FormData(document.getElementById("loginForm"))
            const res = await fetch(apiUrl + 'login.php', {
                method: 'POST',
                body: Form
            })
            
            const json = await res.json()
            result = json

            if(result.success) {
                setTimeout(() => { location.reload(); }, 1500);
            }
        },
    });
    export let toggle;
</script>

{#if $isSubmitting}
    <Spinner /> {$_("components.Forms.LoginForm.loading")}...
{/if}

{#if result}
    {#key result}
        {#if result.error}
            <Alert color="danger" dismissible>{result.error}</Alert>
        {/if}
        {#if result.success}
            <Alert color="success" dismissible>{result.success}</Alert>
        {/if}
    {/key}
{/if}

<form on:submit|preventDefault={handleSubmit} id="loginForm" class="needs-validation" novalidate>
    <Email 
        name="email"
        autocomplete="email"
        label={$_("components.Forms.LoginForm.email")}
        feedback={$errors.email}
        bind:value={$form.email}
        on:change={handleChange}
        on:blur={handleChange}
        autofocus="true"
    />
    <Password 
        name="password"
        autocomplete="current-password"
        label={$_("components.Forms.LoginForm.password")}
        feedback={$errors.password}
        bind:value={$form.password}
        on:change={handleChange}
        on:blur={handleChange}
    />
    <Recaptcha />
    <Container>
        <Row>
            <Col lg="6" md="6" sm="6" xs="6">
                <FormGroup>
                    <Input
                        id="keepLogged"
                        name="keepLogged"
                        bind:value={$form.keepLogged}
                        on:change={handleChange}
                        on:blur={handleChange} 
                        type="checkbox"
                        label="{$_("components.Forms.LoginForm.keepLogged")}"
                        checked
                    />
                </FormGroup>
            </Col>
            <Col lg="6" md="6" sm="6" xs="6">
                <a href="#modal" on:click={toggle}>{$_("components.Forms.LoginForm.forgotPassword")}</a>
            </Col>
        </Row>
    </Container>
    <div class="d-grid gap-2">
        <input type="submit" class="btn btn-primary" disabled={!$isValid} value={$_("components.Forms.LoginForm.send")} />
    </div>
</form>